import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import Logo from '~/images/apps/logo.jpg';
import { Drawer, IconButton, List, Tooltip } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import { CollapseOpenIcon, MenuIcon } from '@import/icons';
import { DrawerCollapseChildrenContentStyled, DrawerCollapseChildrenStyled, drawerWidth, LogoWrapperStyled, MenuItemListSideBar } from '@libs/@core/components/drawer/BaseDrawerDesktop.styled';
var BaseDrawerChild = function (_a) {
    var _b;
    var item = _a.item, isChild = _a.isChild, isOpenDrawer = _a.isOpenDrawer;
    var navigate = useNavigate();
    var location = useLocation();
    var _c = useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var _d = useState(null), selectedItem = _d[0], setSelectedItem = _d[1];
    var _e = useState(0), drawerHeight = _e[0], setDrawerHeight = _e[1];
    var refDrawer = useRef(null);
    useEffect(function () {
        if (!item.children)
            return;
        setDrawerHeight(refDrawer.current.clientHeight);
        if (item.children.some(function (child) { return location.pathname.includes(child.path); })) {
            setSelectedItem(item.id);
        }
    }, [location, item]);
    var handleChangeStateCollapse = function (event) {
        if (isOpenDrawer) {
            setSelectedItem(function (prev) { return (!!prev ? null : item.id); });
        }
        else {
            setAnchorEl(event.currentTarget);
        }
    };
    var handleSwitchRoute = function (path) {
        if (path) {
            navigate(path);
        }
    };
    var open = Boolean(anchorEl);
    var id = open ? 'simple-popover' : undefined;
    if (item.children && item.children.length > 0) {
        return (_jsxs(DrawerCollapseChildrenStyled, { id: id, orientation: 'vertical', in: !!selectedItem, collapsedSize: drawerHeight, children: [_jsxs(MenuItemListSideBar, { className: clsx({
                        active: item.children.some(function (child) { return location.pathname.includes(child.path); })
                    }), ref: refDrawer, onClick: handleChangeStateCollapse, children: [_jsx("div", { className: 'icon', children: item.icon }), isOpenDrawer && (_jsxs(_Fragment, { children: [_jsx("p", { children: item.text }), _jsx("div", { className: "".concat(!!selectedItem ? 'open' : 'close'), children: _jsx(CollapseOpenIcon, {}) })] }))] }), _jsx(DrawerCollapseChildrenContentStyled, { children: item.children.map(function (child, index) { return (_jsx(BaseDrawerChild, { isChild: true, item: child, isOpenDrawer: isOpenDrawer }, "".concat(child.text, "_").concat(index))); }) })] }));
    }
    return (_jsx(Tooltip, { title: item.text, placement: 'right', disableHoverListener: isOpenDrawer, children: _jsxs(MenuItemListSideBar, { className: clsx((_b = {
                    active: !isChild && item.path !== '/' ? location.pathname.includes(item.path) : item.path === location.pathname
                },
                _b['active-child'] = isChild && location.pathname.includes(item.path),
                _b)), onClick: function () { return handleSwitchRoute(item === null || item === void 0 ? void 0 : item.path); }, children: [_jsx("div", { className: 'icon', children: item.icon }), isOpenDrawer && (_jsx(_Fragment, { children: _jsx("p", { children: item.text }) }))] }) }));
};
var BaseDrawerMobile = function (_a) {
    var listItems = _a.listItems, switchIcon = _a.switchIcon;
    var navigate = useNavigate();
    var _b = useState(false), isOpenDrawer = _b[0], setIsOpenDrawer = _b[1];
    var toggleDrawer = function () {
        setIsOpenDrawer(function (prev) { return !prev; });
    };
    var handleGoHome = function () {
        navigate('/');
    };
    return (_jsxs("div", { className: 'max-lg:block hidden relative', children: [!isOpenDrawer && (_jsx(IconButton, { onClick: toggleDrawer, sx: {
                    position: 'absolute',
                    top: '15px',
                    zIndex: 9998
                }, children: switchIcon || _jsx(MenuIcon, { width: 20, height: 20 }) })), _jsx(Drawer, { anchor: 'left', open: isOpenDrawer, onClose: toggleDrawer, children: _jsxs("div", { className: 'px-5 bg-white h-full', children: [_jsx(LogoWrapperStyled, { onClick: handleGoHome, children: _jsx("img", { src: Logo, alt: 'Smart CFO Logo', style: {
                                    width: 260,
                                    margin: '0 8px',
                                    transition: 'width 0.2s',
                                    height: 'auto'
                                } }) }), _jsx(List, { sx: { width: drawerWidth }, children: listItems.map(function (item, index) { return (_jsx(BaseDrawerChild, { isOpenDrawer: isOpenDrawer, item: item }, "".concat(item.text, "_").concat(item.id, "_").concat(index))); }) })] }) })] }));
};
export default BaseDrawerMobile;
